export default {
    init() {
      //console.log("single our work");
    },
    finalize() {

    }
};
